import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { AnalyticsHandlerArguments } from '@atlassian/jira-command-palette/src/common/types/analytics/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	type EventTypes,
	fireUIAnalytics,
	fireTrackAnalytics,
	fireOperationalAnalytics,
	OPERATIONAL_EVENT_TYPE,
	UI_EVENT_TYPE,
	TRACK_EVENT_TYPE,
} from '@atlassian/jira-product-analytics-bridge';

const packageName = 'jiraCommandPaletteIntegration';

export const handleAnalytics = (
	event: UIAnalyticsEvent,
	eventType: EventTypes,
	args?: AnalyticsHandlerArguments,
): void => {
	const eventFunctions: {
		[key in EventTypes]?:
			| typeof fireUIAnalytics
			| typeof fireTrackAnalytics
			| typeof fireOperationalAnalytics
			| undefined;
	} = {
		[UI_EVENT_TYPE]: fireUIAnalytics,
		[TRACK_EVENT_TYPE]: fireTrackAnalytics,
		[OPERATIONAL_EVENT_TYPE]: fireOperationalAnalytics,
	};

	if (
		(args?.actionSubject && args?.action) ||
		(event.payload.actionSubject && event.payload.action)
	) {
		const eventActionAndSubject: `${string} ${string}` =
			args?.actionSubject && args?.action
				? `${args?.actionSubject} ${args?.action}`
				: `${event.payload.actionSubject} ${event.payload.action}`;

		if (args?.actionSubjectId) {
			eventFunctions[eventType]?.(
				event,
				eventActionAndSubject,
				args?.actionSubjectId,
				args?.attributes ? args?.attributes : {},
			);
			return;
		}
		if (!args?.actionSubjectId) {
			eventFunctions[eventType]?.(
				event,
				eventActionAndSubject,
				args?.attributes ? args?.attributes : {},
			);
		}
	} else {
		fireErrorAnalytics({
			error: new Error('Action or ActionSubject not provided'),
			meta: {
				id: 'jira.commandPalette.analytics',
				packageName,
				teamName: 'deliveroo',
			},
		});
	}
};
